<dialog #dialog [class.exist-animation]="existAnimationEnabled" [class]="modalClasses">
    <ng-container [ngTemplateOutlet]="template"></ng-container>
</dialog>